import { MatDialogConfig } from '@angular/material/dialog';

import { DeviceMaxSize } from 'app/constants/common.constants';
import { Column } from 'app/models/columns-dialog.models';

export const getDialogConfig = ({
  columns,
  defaultColumns,
  displayedColumns,
}: {
  columns: Column[];
  defaultColumns: string[];
  displayedColumns: string[];
}): MatDialogConfig => {
  const dialogConfig = new MatDialogConfig();

  dialogConfig.disableClose = false;
  dialogConfig.autoFocus = true;
  dialogConfig.position = {
    top: '48px',
    left: '0',
  };
  if (window.innerWidth <= DeviceMaxSize.TABLET_HORIZONTAL) {
    dialogConfig.height = '100%';
  }
  dialogConfig.maxWidth = '100vw';
  dialogConfig.width = '100%';
  dialogConfig.restoreFocus = false;
  dialogConfig.panelClass = 'filter-dialog';
  dialogConfig.data = {
    columns: columns,
    defaultColumns: defaultColumns,
    selectedColumns: displayedColumns,
  };

  return dialogConfig;
};
